
import { Interaction } from "./interaction.abstract";


export type StatusComplain = 'open' | 'closed' | 'deny' | 'actionRequired' | 'working';

export const ComplainSteps = {
    //textos unificados (AF340): el estado dice cómo está la entrada; el botón, qué hacer
    open:{label:'Con AdminAI', step: 1, variant:'waiting'},
    closed:{label:'Resuelto', step: 1, variant:'success'},
    deny:{label:'Rechazado', step: 1, variant:'error'},
    actionRequired:{label:'Por atender', step: 1, variant:'action'},
    working:{label:'Trabajo en curso', step: 1, variant:'working'}
}

export interface ComplainResolver {
  firstName: string;
  lastName: string;
  phone?: string;
  myProviderId?: string; //si la persona viene de la agenda de prestadores del administrador
}

export interface Complain extends Interaction {
   // texto y color que ve el usuario: el mapa *Steps de este archivo (vocabulario de AF340)
  status: StatusComplain;
  resume: string; // descripción corta del agente (es casi un subtitulo, por ejemplo “problema de humedad”)
  detail: string; // descripción larga del agente . cuenta con mas detalle el caso , ej; “la vecina del 5B tiene problema de humedad y solicita un profesional. Sugiere que el del 6B tiene problemas con el agua que se filtran a su departamento”
  images: string[]; // solo los reclamos lo tienen. es un array de urls de las imágenes que pueden incluirse al momento de hacer el reclamo.
  urgent: boolean;
  closedBy: 'agent' | 'human'; //por defecto es cerrado por el agente, pero si el consorcista cierra la consulta, se marca como cerrado por humano. Esto es para tener un mejor control de las consultas y saber si el agente esta cerrando las consultas o no.
  resolutionNote?: string; //como se resolvió el reclamo, cargado por el administrador al cerrarlo con "solo resolver"
  resolvedBy?: string; //administrationUserId de quien resolvió el reclamo
  resolvers?: ComplainResolver[]; //prestadores o personas que resolvieron el reclamo, cargados junto a la nota de resolución
}

export interface newComplain extends Omit<Complain, 'uid' | 'createdAt' | 'status' | 'nro' | 'id'|'consorcioId' | 'consorcioName' | 'images' | 'consorcista' | 'consorcistaId'>{};



export const SUBCOLLECTION = 'complains';
export type Model = Complain;